@if (availableTags.length || selectedTags.length || tagFilterCategories.length) {
  <accordion [openByDefault]="true" [ariaLabel]="titleText">
    <div header>
      <toggle [on]="isEnabled" (toggle)="handleEnabledToggle($event)"></toggle>
      <h2>{{titleText}}</h2>
    </div>
    @if (selectedTags.length) {
      <div class="badges" [class.disabled]="!isEnabled">
        @for (tag of selectedTags; track trackByTagId($index, tag)) {
          <button aria-label="Remove Tag Filter" (click)="handleTagRemove(tag)">
            <badge icon="x" [value]="tag.Name"></badge>
          </button>
        }
      </div>
    }
    <div body>
      @if (availableTags.length || selectedTags.length) {
        <mat-select (selectionChange)="handleTagSelect($event)" [(value)]="selectedTag" [placeholder]="placeholderText" [aria-label]="placeholderText">
          @for (tag of availableTags; track trackByTagId($index, tag)) {
            <mat-option [value]="tag">
              {{tag.Name}}
            </mat-option>
          }
        </mat-select>
      }
      <ng-template #nodeTemplate let-node="node">
        <div class="tag-filter-node" [class.leaf]="!node.children.length">
          <div class="tag-filter-node-header">
            <label>{{node.label}}{{node.children.length ? ':' : ''}}</label>
            @if (node.isToggleable) {
              <toggle [on]="isNodeSelected(node)" [ariaLabel]="node.label" (toggle)="handleNodeToggle(node, $event)"></toggle>
            }
          </div>
          @if (node.children.length) {
            <div class="tag-filter-node-children">
              @for (child of node.children; track child.key) {
                <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: child }"></ng-container>
              }
            </div>
          }
        </div>
      </ng-template>
      @for (category of tagFilterCategories; track category.key) {
        <ng-container *ngTemplateOutlet="nodeTemplate; context: { node: category }"></ng-container>
      }
    </div>
  </accordion>
}
